@if (noSearchResult) {
<div
  class="m-auto text-muted h2-font-size text-center"
  i18n="AccountsList|No accounts result@@noAccounts"
>
  No search result
</div>
}
<div class="d-flex flex-column position-relative" #accountList>
  <atx-infinite-scroll (scrolled)="onScroll()" class="w-100">
    <article
      *rxFor="
        let account of accounts;
        trackBy: trackByAccountId;
        strategy: 'low'
      "
      data-e2e="active-account-container"
      atxInfiniteScrollItem
      [class.selected]="isAccountSelected(account)"
      [atxTextFinder]="addressParts"
      [atxTextFinderString]="searchValue"
      [atxTextFinderCallback]="highlightCb"
      [atxTextFinderEnabled]="shouldHighlightAddress"
    >
      <div [ngClass]="isSingleSelection ? 'custom-radio' : 'custom-checkbox'">
        @if (isSingleSelection) {
        <input
          type="radio"
          [attr.data-e2e]="'account-checkbox-' + account.externalId"
          class="custom-control-input"
          [id]="account.accountId"
          name="selected-account"
          [value]="account.accountId"
          [checked]="isAccountSelected(account)"
          (click)="handleAccountSelectionChange($event, account)"
        />
        } @else {
        <input
          [atxIndeterminate]="isIndeterminate(account)"
          class="custom-control-input"
          type="checkbox"
          [attr.data-e2e]="'account-checkbox-' + account.externalId"
          (click)="handleAccountSelectionChange($event, account)"
          [id]="account.accountId"
          [checked]="isAccountSelected(account)"
        />
        }
        <label
          class="custom-control-label account-label pb-1 cursor-pointer w-100"
          [for]="account.accountId"
        >
          <epc-account-details [account]="account"></epc-account-details>
          @if (account.shipToAddresses.length === 1) {
          <br />
          <span class="text-muted" data-e2e="address-detail">
            {{ getFullShipToAddress(account.shipToAddresses[0]) }} -
            {{ account.shipToAddresses[0].realAddressId }}
          </span>
          }
        </label>
      </div>
      @if (account.shipToAddresses.length > 1) { @if ( isMoveBasketEnabled &&
      !isCurrentBasketAccount(account)) {
      <div
        (click)="handleAccountSelectionChange($event, account)"
        class="cursor-pointer"
      >
        @for ( address of account.shipToAddresses; track address.addressId) {
        <span class="d-flex flex-column address-label py-1">
          <span
            #addressPartRef
            data-address-part-ref
            class="font-weight-medium"
            data-e2e="address-name"
          >
            {{ address.name }} - {{ address.realAddressId }}
          </span>
          <span
            #addressPartRef
            data-address-part-ref
            class="text-muted"
            data-e2e="address-details"
            >{{ getFullShipToAddress(address) }}</span
          >
        </span>
        }
      </div>
      } @else { @for ( address of account.shipToAddresses; track
      address.addressId) {
      <div class="custom-checkbox">
        <input
          [attr.data-e2e]="'address-checkbox-' + address.name"
          class="custom-control-input"
          type="checkbox"
          [id]="account.accountId + address.addressId"
          [checked]="isAddressSelected(address)"
          (change)="handleAddressSelectionChange($event, address, account)"
        />
        <label
          class="custom-control-label address-label py-1 cursor-pointer"
          [for]="account.accountId + address.addressId"
        >
          <span #addressPartRef>
            <span class="font-weight-medium" data-e2e="address-name">
              {{ address.name }} - {{ address.realAddressId }}
            </span>
            <br />
            <span class="text-muted" data-e2e="address-details">{{
              getFullShipToAddress(address)
            }}</span>
          </span>
        </label>
      </div>
      } } }
    </article>
  </atx-infinite-scroll>
  @if (loading) {
  <div class="align-self-center text-muted">
    <fa-icon [icon]="['fas', 'spinner']" animation="spin-pulse"></fa-icon>
  </div>
  }
</div>
